import { TContractCallParams, TParsedContractCallParams } from "."
import { getEmptyFunctionCallParams } from "../utils"
import { EDataSource, ESupportedOperations, TComputeStepParams } from "./Operations"

export const emptyCallParam: TContractCallParams = {
    contr: '',
    func: '',
    params: [],
    extractItem: 0,
    isResultTuple: false,
    isParam: false,
    value: 0
}

export const emptyOperation: TComputeStepParams = {
    itemOne: 0,
    itemTwo: 1,
    operation: ESupportedOperations.add,
    sourseOne: EDataSource.Requests,
    sourseTwo: EDataSource.Requests,
}

export const emptyParsedParams: TParsedContractCallParams = {
    contr:          '0x8cE9Edd9FeE8bEbbF33d059602Fbd487fdEB3661',
    func:           '0x00000000',
    params:         '0x',
    extractItem:    0,
    isResultTuple:  false,
    isParam:        false,
    value:          0
}